import { useRef, useState } from 'react'
import * as React from 'react'

type TuseDropdown = () => [React.RefObject<HTMLDivElement>, boolean, () => void]

function assertIsNode(e: EventTarget | null): asserts e is Node {
  if (!e || !('nodeType' in e)) {
    throw new Error(`Node expected`)
  }
}

const useDropdown: TuseDropdown = () => {
  const menuRef = useRef<HTMLDivElement>(null)
  const [isDropdownOpened, setIsDropdownOpened] = useState(false)

  React.useEffect(() => {
    return () => {
      window.removeEventListener('click', handleClick)
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  const handleClick: (this: Window, e: MouseEvent) => void = (e) => {
    if (!menuRef.current) return
    assertIsNode(e.target)

    if (menuRef.current.contains(e.target) === false) {
      setIsDropdownOpened(false)
      window.removeEventListener('click', handleClick)
    }
  }

  const handleKeyDown: (this: Window, e: KeyboardEvent) => void = (e) => {
    if (!(e.key === 'Enter') || !menuRef.current) return
    assertIsNode(e.target)
    setIsDropdownOpened(false)
    window.removeEventListener('keydown', handleKeyDown)

    const targetInputName = (e.target as HTMLInputElement).name
    const inputElement = document.querySelector(
      `input[name="${targetInputName}"]`,
    ) as HTMLElement

    inputElement?.blur()
  }

  const toggleDropdown = () => {
    setIsDropdownOpened((prev) => !prev)

    window.removeEventListener('click', handleClick)
    window.addEventListener('click', handleClick)

    window.removeEventListener('keydown', handleKeyDown)
    window.addEventListener('keydown', handleKeyDown)
  }

  return [menuRef, isDropdownOpened, toggleDropdown]
}

export default useDropdown
